// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__13bGL","validationTips":"StatementDescriptor_validationTips__1v7qF"};